import { useEffect } from 'react';
import { useLocation, useParams, useRevalidator, useRouteError } from 'react-router-dom';

import { WorkspaceSkeleton } from '@/app/layouts';
import { logger } from '@/shared';
import { openLeftSidebar } from '@/shared/stores/ui';
import { Button } from '@/shared/ui/shadcn/button';
import { EmptyState, LeftHoverSidebar } from '@/shared/ui/primitives';
import { AlertTriangle } from 'lucide-react';

import { PatientNavigatorContent } from './PatientNavigatorContent';

export function PatientWorkspaceRouteError() {
  const routeError = useRouteError();
  const location = useLocation();
  const params = useParams();
  const revalidator = useRevalidator();
  const userId = params.userId;

  useEffect(() => {
    logger.error(
      'patient workspace route error',
      {
        surface: 'router',
        operation: 'patientWorkspace.route.errorElement',
        feature: 'patient-workspace',
        pathname: location.pathname,
        userId,
      },
      routeError
    );
  }, [location.pathname, routeError, userId]);

  if (revalidator.state === 'loading') {
    return <WorkspaceSkeleton />;
  }

  return (
    <>
      <div className="flex h-screen w-screen items-center justify-center bg-background p-6">
        <EmptyState
          icon={<AlertTriangle className="h-10 w-10" aria-hidden="true" />}
          title="Failed to start workspace"
          description="We couldn't load the patient workspace. Please retry."
          action={
            <div className="flex gap-2">
              <Button type="button" onClick={openLeftSidebar}>
                Select patient
              </Button>
              <Button type="button" variant="secondary" onClick={() => revalidator.revalidate()}>
                Retry
              </Button>
            </div>
          }
        />
      </div>
      <LeftHoverSidebar>
        <PatientNavigatorContent />
      </LeftHoverSidebar>
    </>
  );
}
